import {subscriberAccounts} from './accounts/subscription';
import {subscriberAssets} from './assets/subscription';

export function subscribeLendingAccount() {
  subscriberAccounts();
  subscriberAssets();
}
